import UserImgComponent from "./UserImgComponent";

export default UserImgComponent;
